// Links into the Message service (Mattermost-compatible, REACT_APP_MM_URL).
// A logged-out user is signed in through Keycloak SSO automatically (message
// login page auto-redirect).
const MM_HOST = process.env.REACT_APP_MM_URL || '';
const MM_BASE = (MM_HOST.startsWith('http') ? MM_HOST : `https://${MM_HOST}`).replace(/\/+$/, '');

// Optional: the message team's URL name (e.g. "nexthouse" on QA). With it we
// link straight to /<team>/teams/<channelId>, which every message deployment
// understands; without it we use the /c/<channelId> short link, which needs a
// message server that has that route.
const MM_TEAM_NAME = (process.env.REACT_APP_MM_TEAM_NAME || '').trim();

export const messageChannelUrl = (channelId) => {
  if (!channelId) return `${MM_BASE}/`;
  const id = encodeURIComponent(channelId);
  return MM_TEAM_NAME ? `${MM_BASE}/${encodeURIComponent(MM_TEAM_NAME)}/teams/${id}` : `${MM_BASE}/c/${id}`;
};

/**
 * Open a channel in a new tab. Browsers only allow window.open during the click
 * itself, so flows that must await something first should call
 * reserveMessageTab() in the click handler and pass the result here.
 */
export const openMessageChannel = (channelId, reservedTab) => {
  const url = messageChannelUrl(channelId);
  if (reservedTab && !reservedTab.closed) {
    reservedTab.location.href = url;
    return reservedTab;
  }
  return window.open(url, '_blank');
};

export const reserveMessageTab = () => {
  const tab = window.open('', '_blank');
  if (tab) {
    try {
      tab.document.title = 'Opening messages…';
      tab.document.body.innerHTML = '<p style="font-family:sans-serif;padding:24px">Opening messages…</p>';
    } catch (e) {
      // ignore
    }
  }
  return tab;
};

/** Same-tab redirect into a channel (used right after creating a request). */
export const goToMessageChannel = (channelId) => {
  window.location.assign(messageChannelUrl(channelId));
};
